import axios from 'axios';
import Swal from 'sweetalert2';

/**
 * Fetches the current logged-in user's personal Gemini API key.
 * @param {string} email - The user's email address.
 * @returns {Promise<string|null>} - The decrypted API key or null if not found.
 */
export const getUserGeminiKey = async (email) => {
    if (!email) return null;
    try {
        const res = await axios.get(`https://server.enjoywiki.com/youtubeai-may/api/user-gemini-key?email=${email}`);
        if (res.data.success && res.data.key) {
            return res.data.key;
        }
        return null;
    } catch (error) {
        console.error("Error fetching user Gemini key:", error);
        return null;
    }
};

/**
 * Shows a warning popup if the user hasn't set their API key.
 */
export const showKeyWarning = () => {
    Swal.fire({
        title: 'API Key Required',
        text: 'Please set your Gemini API key in the Tools Homepage first before generating content.',
        icon: 'warning',
        confirmButtonText: 'Go to Settings',
        confirmButtonColor: '#4285F4',
        showCancelButton: true,
        cancelButtonText: 'Maybe Later',
        background: '#161625',
        color: '#ffffff',
        customClass: {
            popup: 'gemini-warning-popup',
            title: 'text-white',
            htmlContainer: 'text-secondary'
        }
    }).then((result) => {
        if (result.isConfirmed) {
            window.location.href = '/';
        }
    });
};

/**
 * Validates if the user has an API key and shows a warning if not.
 * @param {string} email - The user's email address.
 * @returns {Promise<string|null>} - The key if exists, otherwise null (and shows warning).
 */
export const validateGeminiKey = async (email) => {
    const key = await getUserGeminiKey(email);
    if (!key) {
        showKeyWarning();
        return null;
    }
    return key;
};

/**
 * Gets the configured text generation model from local storage, or defaults to gemini-2.5-flash-lite
 */
export const getGeminiTextModel = () => {
    return localStorage.getItem('geminiTextModel') || 'gemini-2.5-flash-lite';
};

/**
 * Gets the configured image generation model from local storage, or defaults to gemini-2.0-flash-exp-image-generation
 */
export const getGeminiImageModel = () => {
    return localStorage.getItem('geminiImageModel') || 'gemini-2.0-flash-exp-image-generation';
};
